// Edit service new
import React, { useContext, useEffect, useState, useRef } from "react";
import Axios from "axios";
import * as yup from 'yup'
import Script from "react-load-script";
import { isEmpty, map, orderBy, cloneDeep } from "lodash";
import { CloseOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { Drawer, message, Select, Input, Button, InputNumber } from "antd";
import axios from "../../../../../Lib/axios";
import Loader from "../../../../Common/Component/Loader";
import CustomMap from "../../../ProposalDetail/Component/Common/CustomMap";
import EditGreen from '../../../../../Assets/images/edit-pencil-green.svg';
import addGreenCircle from '../../../../../Assets/images/add-circle-outline-green.svg';
import DefineCoordinates from "../../../ProposalDetail/Component/Service/Proposal/DefineCoordinates";
import { DeleteFilled } from '@ant-design/icons';
import AllState from "../../../../../Assets/data/stateList.json";
import moment from 'moment';
import workOrderStatus from '../../../../Common/workOrderStatus.json';
import cross_icon from "../../../../../Assets/images/cross_icon.svg";
import TextArea from "antd/lib/input/TextArea";
import CurrencyFormat from 'react-currency-format';
import {errorHandle} from "../../../../Common/errorHandle";
import { formatToCurrency } from "../../../../../Tools/formatToCurrency";
import BigNumber from "bignumber.js";
// import DefineLocation from "../../../ProposalDetail/Component/Service/Proposal/DefineLocation";

const PageContext = React.createContext();
const { Option } = Select;

yup.addMethod(yup.string, 'isCoordinatesValid', function (msg) {
  return this.test('is-coordinates-valid', msg, function (value) {
    try {
      if (value) {
        let coordinates = value.split(',');
        if (coordinates.length === 2) {
          let lat = Number(coordinates[0]);
          let lng = Number(coordinates[1]);
          // if lat is -90 to 90 and lng is -180 to 180 then it is valid
          if (lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
            return true;
          }
        }
      }
      return false;
    } catch (error) {
      return false;
    }
  });
});

export default function EditServiceNew(props) {
  const [state, setState] = useState({ errors: {} });
  const [loader, setLoader] = useState(false);
  return (
    <PageContext.Provider value={{ state, setState, loader, setLoader, clearState: () => { setState(s => ({...s, errors: {} })) }, ...props }}>
      <EditServiceNew_ />
    </PageContext.Provider>
  )
}

// mapping frequency for hardcoded
const FREQUENCY_MAPPING = [
  {
    value: 'weekly',
    key: 'Weekly',
  },
  {
    value: 'bi_monthly',
    key: 'Every Other Week',
  },
  {
    value: 'once',
    key: 'Just Once',
  },
  {
    value: 'twice_weekly',
    key: 'Twice Weekly',
  },
  {
    value: 'monthly',
    key: 'Monthly',
  }
];

// mapping for days
const days = ['sun', 'mon', 'tues', 'wed', 'thurs', 'fri', 'sat'];

const PRODUCT_TYPE_MAPPING = [
  { value: 'pet_waste_stations', key: 'Pet Waste Stations' },
  { value: 'pet_waste_station_bags', key: 'Pet Waste Station Bags' },
  { value: 'other', key: 'Other' }
]

const SERVICE_TYPE_MAPPING = [
  { value: 'pet_waste_station_service', key: 'Pet Waste Station Service' },
  { value: 'common_area_cleaning', key: 'Common Area Cleaning' },
  { value: 'trash_can_service', key: 'Trash Can Service' },
  { value: 'repair', key: 'Repair' },
  { value: 'other', key: 'Other' }
]

const PRODUCT_TYPE = {
  'pet_waste_stations': 'Pet Waste Stations',
  'pet_waste_station_bags': 'Pet Waste Station Bags',
  'other': 'Other'
}

const SERVICE_TYPE = {
  'pet_waste_station_service': 'Pet Waste Station Service',
  'common_area_cleaning': 'Common Area Cleaning',
  'trash_can_service': 'Trash Can Service',
  'repair': 'Repair',
  'other': 'Other'
}

function EditServiceNew_() {
  const ctx = useContext(PageContext);
  const { 
    state,
    setState,
    loader,
    setLoader,
    editService,
    selectedService,
    customer,
    goback = () => { }
  } = ctx;
  const {
    tech_list,
    uuid,
    service_type,
    frequency,
    preferred_start_date,
    cleaning_notes,
    disposal_location,
    service_unavailable_days,
    service_order_number,
    security_code,
    commercial_work_order_line_items = [],
    commercial_detail,
    preferredServiceDays = [],
    header_bag_price,
    roll_bag_price,
    commercial_service_coordinates,
    rawAddress,
    is_manual_address = false,
    address_obj,
    address_obj_manual,
    geo_location,
    is_address_exist = true,
    total,
    original_data,
    commercial_order_line_item_type = "service",
    showCoordinates = false,
    coordinateIndex = 0,
    coordinate = {
      image: '',
      pdf: '',
      markers: []
    },
    coordinates = '',
    nickname,
  } = state;

  useEffect(() => {
    setLoader(true);
    let obj;

    axios.get(`/commercial-service-order/${selectedService.uuid}`)
      .then(response => {

        map(response?.data?.commercial_detail?.line_items, (line_items) => {
          line_items["markers"] = getTotalForCoordinated(line_items.coordinates);
          line_items["totalCoordinates"] = line_items.markers.length;
        });

        let refactored_line_items = [...response?.data?.commercial_detail?.line_items] || [];

        refactored_line_items.forEach(item => {
          item.miscallaneous_services?.forEach(misc => {
            misc.formatted_price = formatToCurrency(misc.price);
            misc.price = new BigNumber (misc.price);
          })
        });

        obj = {
          original_data: [...response?.data?.commercial_detail?.line_items] || [],
          uuid: response?.data?.uuid || null,
          service_type: response?.data?.service_type || '',
          frequency: response?.data?.frequency || null,
          preferred_start_date: response?.data?.preferred_start_date || null,
          cleaning_notes: response?.data?.cleaning_notes || null,
          disposal_location: response?.data?.disposal_location || null,
          service_unavailable_days: response?.data?.service_unavailable_days || [],
          service_order_number: response?.data?.service_order_number || null,
          security_code: response?.data?.security_code || null,
          is_active: response?.data?.is_active || false,
          header_bag_price: response?.data?.header_bag_price || 0,
          roll_bag_price: response?.data?.roll_bag_price || 0,
          next_service_date: response?.data?.next_service_date || null,
          previous_service_date: response?.data?.previous_service_date || null,
          is_paused: response?.data?.is_paused || null,
          pause_obj: response?.data?.pause_obj || null,
          average_clean_time: response?.data?.average_clean_time || null,
          commercial_detail: response?.data?.commercial_detail || null,
          commercial_work_order_line_items: refactored_line_items,
          user_id: response?.data?.user_id || null,
          user_uuid: response?.data?.user_uuid || null,
          preferred_technician: response?.data?.preferred_technician?.uuid || null,
          commercial_order_line_item_type: response?.data?.commercial_order_line_item_type || null,
          commercial_service_coordinates: response?.data?.commercial_service_coordinates ? getTotalForCoordinated(response?.data?.commercial_service_coordinates) : null,
          preferredServiceDays: days?.filter(x => !response?.data?.service_unavailable_days?.includes(x)).length < 7  ? days?.filter(x => !response?.data?.service_unavailable_days?.includes(x)) : ['any'], //days?.filter(x => !response?.data?.service_unavailable_days?.includes(x)),
          showCoordinates: false,
          coordinateIndex: 0,
          coordinate: {
            image: '',
            pdf: '',
            markers: []
          },
          currentPosition: response?.data?.service_address?.geo_location?.latitude ? { lat: response?.data?.service_address?.geo_location?.latitude, lng: response?.data?.service_address?.geo_location?.longitude } : {},
          address_obj: {
            address: response?.data?.service_address?.address || "",
            city: response?.data?.service_address?.city || "",
            state: response?.data?.service_address?.state || "",
            zip_code: response?.data?.service_address?.zip_code || "",
          },
          rawAddress: response?.data?.service_address?.formatted_address?.replace("  "," ")?.replace(", , .","")?.replace(", ,","")?.trim(),
          coordinates: response?.data?.service_address?.geo_location?.latitude ? `${response?.data?.service_address?.geo_location?.latitude}, ${response?.data?.service_address?.geo_location?.longitude}` : null,
          is_address_exist: true,
          nickname: response?.data?.community_nickname
        };

        setState(s => ({...s, ...obj}));
        setLoader(false);
      })
      .catch(error => {
        setLoader(false);
        console.error(error);
      });

    axios.get(`/ftech/field-technicians/`, {params: {"field_office__uuid": customer.field_office.uuid}})
      .then(response => {
        if(response)
        {
          setState(s => ({...s, tech_list: response?.data}));
          setLoader(false);
        }
      })
      .catch(error => {
        setLoader(false);
        console.error(error);
      });
  }, [])

  const getTotalForCoordinated = (item) => {
    var _markers = [], multiple_locations = item;
    let locations = multiple_locations?.split('MULTIPOINT')[1];
    locations = locations?.trim().substr(1, locations.trim().length - 2);
    let temp = locations?.split(', ');
    map(temp, (obj) => _markers.push({ lat: obj.split(' ')[0], lng: obj.split(' ')[1] }));
    return _markers;
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const validate = () => {

    if (commercial_work_order_line_items && commercial_work_order_line_items.length === 0) {
      message.error(`You must add at least one ${commercial_order_line_item_type}.`, 10);
    } else {
      const schema = yup.object().shape({
        // yup custom regex validation for geo coordinates string format: "lat,lng"
        ...(coordinates ? {
          coordinates: yup.string()
            .isCoordinatesValid("Please enter valid coordinates")
        } : {}),
        // ...((!is_manual_address && !coordinates) ? { rawAddress: yup.string().required("Select address") } : null),
        ...((is_manual_address && !coordinates) ? { address: yup.string().required("Enter address") } : null),
        ...((is_manual_address && !coordinates) ? { city: yup.string().required("Enter city") } : null),
        ...((is_manual_address && !coordinates) ? { state: yup.string().required("Select state") } : null),
        ...((is_manual_address && !coordinates) ? { zip_code: yup.string().required("Enter zipcode") } : null),
        ...(commercial_order_line_item_type === "service" ? { preferredServiceDays: yup.array().min(1, "Preferred service days is required") } : null),
        ...(commercial_order_line_item_type === "service" ? { frequency: yup.string().required('Frequency is required.') } : null),
        ...(commercial_order_line_item_type === "service" ? { header_bag_price: yup.string().required('Enter header bag price.') } : null),
        ...(commercial_order_line_item_type === "service" ? { roll_bag_price: yup.string().required('Enter roll bag price.') } : null),
        commercial_work_order_line_items: yup.array(yup.object({
          ...(commercial_order_line_item_type === "service" ? { item: yup.string().required('Select service'), } : null),
          ...(commercial_order_line_item_type === "product" ? { item: yup.string().required('Select service'), } : null),
          ...(commercial_order_line_item_type === "product" ? { model: yup.string().typeError('Select model').required('Select model') } : null),
          model: yup.string().test('match', 'Model is required', function (model) {
            if (commercial_order_line_item_type === 'product') {
              if (this.parent.item === 'other') {
                return true;
              } else {
                return model;
              }
            } else {
              return true
            }
          }),

          ...(commercial_order_line_item_type === "service" ? { coordinates: yup.string().typeError('Enter coordinates').required('Enter coordinates') } : null),
          quantity: yup.number().typeError('Enter quantity').required('Enter quantity'),
          rate: yup.number().typeError('Enter rate').required('Enter rate'),
          ...(commercial_order_line_item_type === "product" ? { s_and_h: yup.number().typeError('Enter shipping and handling').required('Enter shipping and handling') } : null),
          miscallaneous_services: yup.array(yup.object({
            mis_type:yup.string().oneOf(["product", "service"]).required('Select one'),
            item: yup.string().required('Enter item'),
            price: yup.number().typeError('Enter valid price').required('Enter price'),
          })),
        }))
      });
      if (!is_manual_address && !rawAddress && !coordinates) {
        setState(s => ({ ...s, is_address_exist: false }));
      } else {
        const data = {
          preferredServiceDays,
          frequency,
          header_bag_price,
          roll_bag_price,
          commercial_work_order_line_items,
          coordinates,
          address: is_manual_address ? address_obj_manual?.address : address_obj?.address,
          city: is_manual_address ? address_obj_manual?.city : address_obj?.city,
          state: is_manual_address ? address_obj_manual?.state : address_obj?.state,
          zip_code: is_manual_address ? address_obj_manual?.zip_code : address_obj?.zip_code,
        };
        schema.validate(data, { abortEarly: false }).then(() => {
          setState(s => ({ ...s, errors: {}, is_address_exist: true }));
          updateServiceOrder();
        }).catch((error) => {
          let err_data = {};
          map(error.inner, (item) => { err_data[item.path] = item.message });
          setState(s => ({ ...s, errors: err_data, is_address_exist: true }));
        })
      }
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const updateServiceOrder = () => {
    setLoader(true);

    const service_address_data = {
      address: is_manual_address ? address_obj_manual?.address : address_obj?.address,
      city: is_manual_address ? address_obj_manual?.city : address_obj?.city,
      state: is_manual_address ? address_obj_manual?.state : address_obj?.state,
      zip_code: is_manual_address ? address_obj_manual?.zip_code : address_obj?.zip_code,
      ...coordinates?.trim()?.split(',')?.length === 2 ? ({
        geo_location: {
          latitude: coordinates?.split(',')[0],
          longitude: coordinates?.split(',')[1]
        }
      }) : ({}),
    }

    if(!service_address_data.address || service_address_data?.address?.trim() === ''){
      service_address_data.address = "";
    }

    if(!service_address_data.city || service_address_data?.city?.trim() === ''){
      service_address_data.city = "";
    }

    if(!service_address_data.state || service_address_data?.state?.trim() === ''){
      service_address_data.state = "";
    }

    if(!service_address_data.zip_code || service_address_data?.zip_code?.trim() === ''){
      service_address_data.zip_code = "";
    }

    let preferred_technician_uuid = state.preferred_technician ? state.preferred_technician : "0000000-0000-0000-0000-0000000000000";

    const data = {
      preferred_technician_uuid,
      service_type: state?.service_type,
      frequency: state?.frequency,
      preferred_start_date: state?.preferred_start_date,
      cleaning_notes: state?.cleaning_notes,
      disposal_location: state?.disposal_location,
      service_unavailable_days: days?.filter(x => !preferredServiceDays?.includes(x)).length !== 7 ?  days?.filter(x => !preferredServiceDays?.includes(x)) : [], //days?.filter(x => !preferredServiceDays?.includes(x)),
      service_order_number: state?.service_order_number,
      security_code: state?.security_code,
      header_bag_price: state?.header_bag_price,
      roll_bag_price: state?.roll_bag_price,
      ...(commercial_work_order_line_items && commercial_work_order_line_items.length > 0 ? {
        commercial_detail: {
          line_items: commercial_work_order_line_items
        }
      } : {}),
      service_address: service_address_data,
      community_nickname: nickname
    };

    axios.patch(`/commercial-service-order/${selectedService.uuid}/`, data).then((response) => {
      message.success(`Changes saved successfully.`, 10);
      setTimeout(() => {
        setLoader(false);
        goback();
      }, 1000);
    }).catch(error => {
      setLoader(false);
      if (error?.response?.data?.service_address) {
        setState(s => ({ ...s, errors: { ...s.errors, service_address: error?.response?.data?.service_address } }));
      }
      if (error?.response?.data?.service_unavailable_days) {
        errorHandle(error?.response?.data?.service_unavailable_days)
      } else {
        message.error(`Error occurred while updating Work order.`, 10);
      }
      
    });
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const filterParams = (params) => {
    for (var propName in params) {
      if (params[propName] === "" || params[propName] === null || params[propName] === "null" || params[propName] === undefined || params[propName] === "undefined") {
        delete params[propName];
      }
    }
    return params
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const onClear = () => {
    goback();
  }

  return (
    <Drawer
      placement={'right'}
      closable={false}
      onClose={goback}
      visible={editService}
      key={'right'}
      width={'525'}
      className="drawer-wrapper"
    >
      <div className="edit-service-drawer rdrawer">
        {loader && <Loader />}
        <React.Fragment>
          <div className="card-head flex ai-center">
            <h4> Edit Service Order</h4>
            <CloseOutlined onClick={() => {
              onClear();
              goback()
            }} />
          </div>
        </React.Fragment>
        <div className="card-row flex flex-column">
          <div className="card-full">
            <div className="item" style={{marginBottom: "15px"}}>
              <label>Service Nickname</label>
              <input
                maxLength={20}
                type="text"
                name="nickname"
                value={state?.nickname}
                onChange={ (e) => 
                  {
                    e.persist();
                    setState(s => ({...s, nickname: e.target.value}));
                  }
                }
              />
            </div>
            <React.Fragment>
              {commercial_order_line_item_type === "service" && <Location />}
            </React.Fragment>
            <React.Fragment>
              <Details />
            </React.Fragment>
            <React.Fragment>
              {commercial_order_line_item_type === "service" && <Services />}
              {commercial_order_line_item_type === "product" && <Products />}
            </React.Fragment>

            <React.Fragment>
              <ServiceTotal />
            </React.Fragment>

            <div className="fitem mt-10">
              <b className="d-block mb-10">Preferred Technician</b>
              <Select
                value={state.preferred_technician && state.tech_list?.results.length > 0 ? state.preferred_technician : undefined}
                showArrow
                allowClear={true}
                virtual={false}
                placeholder={'Select Technician'}
                style={{ width: '100%' }}
                onChange={(e) => {
                  setState(s => ({...s, preferred_technician: e}))
                }}
              >
                <Option value="0000000-0000-0000-0000-0000000000000">Un-Assigned</Option>
                {map(state.tech_list?.results, obj => (
                  <Option
                    key={obj?.uuid}
                    value={obj?.uuid}
                  >
                    {obj?.user?.last_name ? `${obj?.user?.first_name} ${obj?.user?.last_name}` : obj?.user?.first_name}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        </div>

        <React.Fragment>
          <div className="footer">
            <Button className="btn btn-brand btn-bdr" onClick={() => { onClear() }}>Cancel</Button>
            <Button className={`btn btn-primary`} onClick={() => validate()}> Update Service </Button>
          </div>
        </React.Fragment>

      </div>

    </Drawer>
  )
}

function Details(props) {
  const addressRef = useRef(HTMLInputElement);
  const autoCompleteData = useRef();
  const ctx = useContext(PageContext);
  const { state, setState } = ctx;
  const { 
    errors,
    status,
    coordinates,
    commercial_detail,
    header_bag_price,
    roll_bag_price,
    security_code,
    commercial_order_line_item_type,
    is_manual_address,
    address_obj,
    rawAddress,
    is_address_exist = true
  } = state;
  const [manual, setManual] = useState(false)

  // Google Map Place API
  function handleScriptLoad(e) {
    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'formatted_address']);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', handlePlaceSelect);
    autoCompleteData.current = newAutoComplete;

    setState(s => ({
      ...s,
      autocomplete: newAutoComplete
    }));
  }

  function removeEmpty(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => (v !== null && v?.trim() !== "")));
  }

  function handlePlaceSelect() {
    //const autocomplete = autoCompleteData?.current;
    //const addressObject = autocomplete.getPlace();

   const address= document?.getElementById('google_address')?.value;
    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: removeEmpty({
        latlng: undefined,
        address,
        key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
      })
    }).then((res) => {
      const addressObject = res?.data?.results[0];
   
      let obj = {};
      map(addressObject?.address_components, (item) => {
        if (item?.types?.includes('route') || item?.types?.includes('administrative_area_level_2')) {
          obj = Object.assign(obj, { 'address': item.short_name })
        }
        if (item?.types?.includes('route')) {
          obj = Object.assign(obj, { 'route': item.long_name })
        }
        if (item?.types?.includes('street_number')) {
          obj = Object.assign(obj, { 'street_number': item.short_name })
        }
        if (item?.types?.includes('administrative_area_level_1')) {
          obj = Object.assign(obj, { 'state': item.short_name })
        }
        if (item?.types?.includes('locality')) {
          obj = Object.assign(obj, { 'city': item.long_name })
        }
        if (item?.types?.includes('postal_code')) {
          obj = Object.assign(obj, { 'zip_code': item.short_name })
        }
      });

      const address_obj = (obj?.street_number || obj?.route) ? { ...obj, address: `${obj?.street_number || ''} ${obj?.route || ''}` } : obj
      const address = `${address_obj.address} ${address_obj.city} ${address_obj.state} ${address_obj.zip_code}`
      console.warn("val", {
        address_obj,
        address
      });

      setState(s => ({
        ...s,
        address: address,
        address_obj: address_obj,
        rawAddress: address,
      }));
    }).catch((err) => {
      console.log(err)
    })

    // ctx.resetGeocodeAddress()
    // ctx.getGeocodeAddress({ key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY, address })
  }

  /**
   * AUTHOR: Ritesh Solanki
   * @param {*} value 
   */
  const onPreferredDaysChanged = (value) => {
    let is_any_option_selected = value.findIndex(item => item === 'any');
    if(is_any_option_selected > -1 && value.length > 1 && is_any_option_selected !== 0 ){
      setState(s => ({
        ...s,
        preferredServiceDays:['any']
      }));
    }
    else if(is_any_option_selected > -1 && value.length > 1 && is_any_option_selected === 0){
      const removeAny = value.filter(item => item !== 'any');
      setState(s => ({
        ...s,
        preferredServiceDays:removeAny
      }));
    }
    else if( value.length === 7 && is_any_option_selected === -1 ){
      setState(s => ({
        ...s,
        preferredServiceDays:['any']
      }));
    }
    else{
      const removeAny = value.filter(item => item !== 'any');
      setState(s => ({
        ...s,
        preferredServiceDays:removeAny
      }));
    }
    // console.warn('value', value)
    // const isAnyInclude = value[value.length - 1] === "any";
    // let newValue = [];
    // console.warn('isAnyInclude', isAnyInclude)
    // if (isAnyInclude) {
    //   newValue = ["any"];
    // } else {
    //   const idx = value.indexOf("any");
    //   if (idx > -1) value.splice(idx, 1);
    //   newValue = value;
    // }
    // setState(s => ({
    //   ...s,
    //   preferredServiceDays: newValue
    // }));
  };

  return (
    <div className="form-group mt-10">
      <div className="field-group">
        <Script url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
          // onLoad={handleScriptLoad}
          onLoad={() => window.requestAnimationFrame(handleScriptLoad)}
        />
        <label>Service Address</label>
        <Input
          autoComplete="off"
          ref={addressRef}
          className={'google_search_disable form--control'}
          placeholder="Search for address"
          name="google_address"
          id="google_address"
          value={state?.rawAddress}
          disabled={state?.is_manual_address}
          onChange={(e) => {
            if (!e.target.value) {
              setState(s => ({
                ...s,
                address: '',
                address_obj: {},
                rawAddress: ''
              }))
            } else {
              const val = e.target.value;
              setState(s => ({
                ...s,
                rawAddress: val,
              }))
            }
          }}
        />
        {!is_address_exist ? <label className="new_err_msg"><i className="las la-info-circle" />Select address</label> : ''}
      </div>
      <div>
        <b>or <a onClick={(e) => {
          e.preventDefault();
          // setManual(true);
          setState(s => ({
            ...s,
            is_manual_address: true,
            address_obj_manual: { ...state?.address_obj },
          }))
        }}><u>enter address manually</u></a></b>
        {state?.is_manual_address && <div className="manually_address">
          <a onClick={(e) => {
            e.preventDefault();
            // setManual(false);
            setState(s => ({
              ...s,
              is_manual_address: false,
              address: '',
              address_obj: {},
              rawAddress: ''
            }))
          }}><img src={cross_icon} alt="" className="float-right mb-10" /></a>
          <br />
          <div className="form-group mb-20">
            <div className="fitem">
              <input
                type="text"
                placeholder="Address"
                name="address"
                value={state?.address_obj_manual?.address}
                onChange={(e) => {
                  const val = e.target.value;
                  setState(s => ({
                    ...s,
                    address_obj_manual: {
                      ...s.address_obj_manual,
                      address: val
                    },
                  }))
                }}
              />
              {errors?.['address'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['address']}</label> : ''}
            </div>
            <div className="half-fitem fitem">
              <div className="half-fitem fitem">
                <input
                  type="text"
                  placeholder="City"
                  name="city"
                  onChange={(e) => {
                    const val = e.target.value;
                    setState(s => ({
                      ...s,
                      address_obj_manual: {
                        ...s.address_obj_manual,
                        city: val
                      },
                    }))
                  }}
                  value={state?.address_obj_manual?.city}
                />
                {errors?.['city'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['city']}</label> : ''}
              </div>
              <div className="half-fitem fitem">
                <Select
                  showArrow={true}
                  name="state"
                  placeholder="State"
                  onChange={(val) => {
                    setState(s => ({
                      ...s,
                      address_obj_manual: {
                        ...s.address_obj_manual,
                        state: val
                      },
                    }))
                  }}
                  value={state?.address_obj_manual?.state || undefined}
                  virtual={false}
                >
                  {
                    map([
                      {
                        "Name": "State",
                        "abbreviation": "",
                      }
                      , ...AllState.AllState], (item, i) => {
                        return (<Option value={item.abbreviation} key={i}>{item.name}</Option>)
                      })
                  }
                </Select>
                {errors?.['state'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['state']}</label> : ''}
              </div>
              <div className="half-fitem fitem">
                <input
                  type="text"
                  className='form--control'
                  placeholder="ZIP Code"
                  name="zip_code"
                  maxLength={5}
                  minLength={5}
                  value={state?.address_obj_manual?.zip_code || ''}
                  onKeyPress={(e) => {
                    if (![
                      '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
                      'Backspace', 'Tab', 'Enter', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'
                    ].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    const val = e.target.value;
                    setState(s => ({
                      ...s,
                      address_obj_manual: {
                        ...s.address_obj_manual,
                        zip_code: val
                      },
                    }))
                  }}
                />
                {errors?.['zip_code'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['zip_code']}</label> : ''}
              </div>
            </div>
          </div>
        </div>}
      </div>
      <div className="field-group">
        <Input
          placeholder="Enter Coordinates"
          value={coordinates}
          onChange={(e) => {
            e.preventDefault();
            const val = e.target.value || '';
            if (!val?.split(',')?.some(v => isNaN(v) && v?.trim() !== '-') || val === '') {
              setState(s => ({ ...s, coordinates: val }))
            }
            e.persist();
          }}
        />
        {errors?.['coordinates'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['coordinates']}</label> : ''}
        {errors?.['service_address'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['service_address']}</label> : ''}
      </div>

      {commercial_order_line_item_type === "service" && <div className="">
        <div style={{ display: 'flex' }}>
          <div className="field-group mb-10" style={{ width: "50%", paddingRight: 5 }}>
            <label>Preferred Service Days<sup>*</sup></label>
            <div className="position-relative">
              <Select
                mode="multiple"
                showArrow
                virtual={false}
                style={{ width: '100%', height: "auto" }}
                value={state?.preferredServiceDays}
                name={"preferredServiceDays"}
                onChange={(e) => onPreferredDaysChanged(e)}
              >
                <Option value={'any'}>{'Any'}</Option>
                <Option value={'sun'}>{'Sunday'}</Option>
                <Option value={'mon'}>{'Monday'}</Option>
                <Option value={'tues'}>{'Tuesday'}</Option>
                <Option value={'wed'}>{'Wednesday'}</Option>
                <Option value={'thurs'}>{'Thursday'}</Option>
                <Option value={'fri'}>{'Friday'}</Option>
                <Option value={'sat'}>{'Saturday'}</Option>
              </Select>
            </div>
            {errors?.['preferredServiceDays'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['preferredServiceDays']}</label> : ''}
          </div>
          <div className="field-group mb-10" style={{ width: "50%", paddingLeft: 5 }}>
            <label>Frequency<sup>*</sup></label>
            <div className="position-relative">
              <Select
                showArrow
                virtual={false}
                style={{ width: '100%' }}
                placeholder={'Select Regularity'}
                value={state?.frequency ? state?.frequency : undefined}
                onChange={(e) => {
                  if (e) {
                    setState(s => ({ ...s, frequency: e }))
                  } else {
                    setState(s => ({ ...s, frequency: '' }))
                  }
                }}
              >
                {
                  FREQUENCY_MAPPING?.map(obj => <Option value={obj.value} key={obj.value}>{obj.key}</Option>)
                }
              </Select>
            </div>
            {errors?.['frequency'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['frequency']}</label> : ''}
          </div>

        </div>
      </div>}

      <div className="field-group">
        <label>Notes</label>
        <TextArea
          className="form-control service-textarea"
          placeholder="Enter any additional service notes here"
          value={state?.cleaning_notes}
          onChange={(event) => {
            event.persist();
            if (event) {
              setState(s => ({ ...s, cleaning_notes: event?.target?.value }))
            } else {
              setState(s => ({ ...s, cleaning_notes: '' }))
            }

          }}
        ></TextArea>
      </div>

      {commercial_order_line_item_type === "service" && <div className="field-group">
        <label>Security Code</label>
        <Input
          value={state?.security_code}
          placeholder="Security code"
          onChange={(event) => {
            event.persist();
            if (event) {
              setState(s => ({ ...s, security_code: event?.target?.value }))
            } else {
              setState(s => ({ ...s, security_code: '' }))
            }
          }}
        />
      </div>}

      {commercial_order_line_item_type === "service" && <div className="">
        <div style={{ display: 'flex' }}>
          <div className="field-group mb-10" style={{ width: "50%", paddingRight: 5 }}>
            <label>Header Bag Pricing<sup>*</sup></label>
            <div className="position-relative">
              <CurrencyFormat
                value={state.header_bag_price}
                thousandSeparator={true}
                prefix={'$'}
                decimalSeparator={"."}
                decimalScale={2}
                fixedDecimalScale={true}
                allowNegative={false}
                placeholder={"$ 0.00"}
                onValueChange={(values) => {
                  const { formattedValue, value } = values;
                  setState(s => ({ ...s, header_bag_price: value }))
                }} />

              {/* <InputNumber
                defaultValue={0}
                formatter={value => `$ ${value}`}
                value={state?.header_bag_price}
                onChange={(e) => {
                  if (e) {
                    setState(s => ({ ...s, header_bag_price: e }))
                  } else {
                    setState(s => ({ ...s, header_bag_price: '' }))
                  }
                }}
              /> */}
            </div>
            {errors?.['header_bag_price'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['header_bag_price']}</label> : ''}
          </div>
          <div className="field-group mb-10" style={{ width: "50%", paddingLeft: 5 }}>
            <label>Roll Bag Pricing<sup>*</sup></label>
            <div className="position-relative">
              <CurrencyFormat
                value={state.roll_bag_price}
                thousandSeparator={true}
                prefix={'$'}
                decimalSeparator={"."}
                decimalScale={2}
                fixedDecimalScale={true}
                allowNegative={false}
                placeholder={"$ 0.00"}
                onValueChange={(values) => {
                  const { formattedValue, value } = values;
                  setState(s => ({ ...s, roll_bag_price: value }))
                }} />
            </div>
            {errors?.['roll_bag_price'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['roll_bag_price']}</label> : ''}
          </div>

        </div>
      </div>}

    </div>
  )
}

function Location() {
  const ctx = useContext(PageContext);
  const { state, setState, selectedService } = ctx;
  const { location_markers, showLocation, mapZoom = 12, quoteDetail, currentPosition, commercial_service_coordinates } = state;

  const toggleLocation = () => {
    setState(s => ({ ...s, showLocation: !showLocation }))
  }

  return (
    <React.Fragment>
      <div onClick={() => toggleLocation()}>
        {!isEmpty(commercial_service_coordinates) ? !showLocation ? <CustomMap isView={true} markers={commercial_service_coordinates} /> : '' :
          ""
        }
      </div>
      {showLocation && <DefineCoordinates
        isViewOnly={true}
        zoom={mapZoom}
        visible={showLocation}
        quoteDetail={quoteDetail}
        onCancel={() => toggleLocation()}
        markerList={!isEmpty(commercial_service_coordinates) ? commercial_service_coordinates : !isEmpty(currentPosition) ? [] : []}
        currentPosition={!isEmpty(currentPosition) ? [currentPosition] : []}
        address={!isEmpty(selectedService?.service_address?.formatted_address) ? selectedService?.service_address?.formatted_address : ""}
      />
      }
    </React.Fragment>
  )
}

function Services() {
  const ctx = useContext(PageContext);
  const { state, setState, selectedService } = ctx;
  const { 
    errors,
    commercial_work_order_line_items = [],
    commercial_order_line_item_type,
    currentPosition,
    showCoordinates,
    mapZoom,
    coordinate,
    quoteDetail,
    commercial_service_coordinates
  } = state;

  /**
   * AUTHOR: Ritesh Solanki
   */
  const setRows = () => {
    commercial_work_order_line_items.unshift({ 
      id: 0,
      miscallaneous_services: [],
      created_at: moment().format("YYYY-MM-DD hh:mm:ss"),
      modified_at: '',
      item: '',
      model: '',
      markers: [],
      item_type: commercial_order_line_item_type,
      description: '',
      rate: 0,
      quantity: 0,
      total: 0,
      commercial_work_order: '',
      totalCoordinates: 0
    });
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items }));
  }

  const setMiscellaneousRows = (index) => {
    commercial_work_order_line_items[index].miscallaneous_services.push({mis_type:'service', price: '', item: '' });
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items }));
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const onDeleteRowService = (index) => {
    commercial_work_order_line_items.splice(index, 1);
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items }));
  }

  const onMiscellaneousPriceChange = (value, index, formattedValue, parentIndex) => {
    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
    let parent = {...commercial_work_order_line_items_[parentIndex]};
    let miscallaneous_services = [...parent.miscallaneous_services];
    let item = {...miscallaneous_services[index]};

    miscallaneous_services[index] = item;
    let errors_temp = {}
    value = value ? new BigNumber(value.toFixed(2)) : new BigNumber('0');

    let miscTotal = 0;
    map(miscallaneous_services, (obj, index) => {
      if(obj.item !== item.item)
      {
        miscTotal += +obj.price;
      }
    });

    let total = 0;
    const { quantity, rate } = commercial_work_order_line_items_[parentIndex];
    if (quantity && rate) {
      total = (+quantity * +rate)
    }
    if (miscTotal) {
      total += +miscTotal
    }

    let formatted_total = new BigNumber(total.toFixed(2));
    console.log(formatted_total);

    if((formatted_total.plus(value)) < 0)
    {
      value = new BigNumber('0');
      formattedValue = "$0.00";
      errors_temp= {miscellaneous: [{index, name: "price", message: "You can't discount more than the SO total."}]};
    }

    item['price'] = value;
    item['formatted_price'] = formattedValue;
    miscallaneous_services[index] = item;
    parent.miscallaneous_services = [...miscallaneous_services];
    console.log(new BigNumber(formatted_total.plus(item['price'])).toNumber());
    parent['total'] = new BigNumber(formatted_total.plus(item['price'])).toFixed(2);
    commercial_work_order_line_items_[parentIndex] = parent;

    setState(s => ({ ...s, commercial_work_order_line_items: [...commercial_work_order_line_items_] , errors: errors_temp}));
  }

  const onRowDataChange = (value, parentIndex, index, key) => {
    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
    commercial_work_order_line_items_[parentIndex]["miscallaneous_services"][index][key] = value;
    let miscTotal = 0;
    map(commercial_work_order_line_items_[parentIndex]["miscallaneous_services"], (obj, index) => {
      miscTotal += +obj.price;
    })
    let total = 0;
    const { quantity, rate } = commercial_work_order_line_items_[parentIndex];
    if (quantity && rate) {
      total = (+quantity * +rate)
    }
    if (miscTotal) {
      total += +miscTotal
    }
    commercial_work_order_line_items_[parentIndex]['total'] = total || 0.00;
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items_ }))
  }

  const onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  /**
   * AUTHOR: Ritesh Solanki
   */
  const onDeleteRowMisc = (parentIndex, childIndex) => {
    commercial_work_order_line_items[parentIndex].miscallaneous_services.splice(childIndex, 1);
    let miscTotal = 0;
    map(commercial_work_order_line_items[parentIndex]["miscallaneous_services"], (obj, index) => {
      miscTotal += +obj.price;
    })
    const { quantity, rate } = commercial_work_order_line_items[parentIndex];
    commercial_work_order_line_items[parentIndex]['total'] = (quantity && rate) ? ((+quantity * +rate) + +miscTotal) : 0.00;
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items }));
  }

  const onMiscellaneousItemError = (item_index) => {
    let error_index = errors?.miscellaneous?.findIndex(item => item.index === item_index && item.name === "price" );

    if(error_index !== undefined && !(error_index < 0))
    {
      return <label className="new_err_msg">
        <i className="las la-info-circle" />
          {errors?.miscellaneous[error_index]?.message}
      </label>
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const renderItemRow = (parentIndex, miscallaneous_services) => {
    return (<React.Fragment> {map(miscallaneous_services, (item, childIndex) => {
      return (
        <div className="divrow" key={`items${childIndex}`} style={{ marginLeft: "0px", marginBottom: "10px" }}>
          {/* <div className="dcell sprice pt-0 pr-5 pl-0">
            <div className="sprice mr-0">
              <Select
                disabled={true}
                showArrow
                virtual={false}
                style={{ width: '100%' }}
                value={item?.mis_type?item?.mis_type:"Select Type"}
                onChange={(event) => {
                  onRowDataChange(event, parentIndex, childIndex, "mis_type")
                }}
              >
              </Select>
              {errors?.[`commercial_work_order_line_items[${parentIndex}].miscallaneous_services[${childIndex}].mis_type`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${parentIndex}].miscallaneous_services[${childIndex}].mis_type`]===`commercial_work_order_line_items[${parentIndex}].miscallaneous_services[${childIndex}].mis_type must be one of the following values: product, service`?"Select one":`commercial_work_order_line_items[${parentIndex}].miscallaneous_services[${childIndex}].mis_type`}</label> : ''}
            </div>
          </div> */}
          <div className="dcell sprice pt-0 pr-5 pl-0">
            <div className="sprice mr-0">
              <input
                type="text"
                value={item?.item}
                name="item"
                placeholder="Item"
                onChange={(event) => {
                  event.persist();
                  if (event) {
                    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
                    commercial_work_order_line_items_[parentIndex]["miscallaneous_services"][childIndex]["item"] = event?.target?.value;
                    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items_ }))
                  } else {
                    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
                    commercial_work_order_line_items_[parentIndex]["miscallaneous_services"][childIndex]["item"] = "";
                    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items_ }))
                  }
                }}
              />
              {errors?.[`commercial_work_order_line_items[${parentIndex}].miscallaneous_services[${childIndex}].item`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${parentIndex}].miscallaneous_services[${childIndex}].item`]}</label> : ''}
            </div>
          </div>
          <div className="dcell sprice pt-0 pl-5">
            <div className="sprice mr-0" style={{ position: 'relative' }}>
              <CurrencyFormat
                value={item?.formatted_price}
                thousandSeparator={true}
                prefix={'$'}
                decimalSeparator={"."}
                decimalScale={2}
                fixedDecimalScale={true}
                allowNegative={true}
                placeholder={"$ 0.00"}
                onValueChange={(values) => {
                  const { formattedValue, value, floatValue } = values;
                  onMiscellaneousPriceChange(floatValue, childIndex, formattedValue, parentIndex);
                  onNumericInputChange(value)
                }}
              />
              {
                onMiscellaneousItemError(childIndex)
              }
            </div>
          </div>
          <CloseOutlined style={{ marginTop: "14px" }} onClick={() => onDeleteRowMisc(parentIndex, childIndex)}></CloseOutlined>
        </div>
      )
    })}</React.Fragment>)
  }

  /**
   * AUTHOR: Ritesh Solanki
   * @param {*} value 
   * @param {*} index 
   * @param {*} key 
   */
  const onLineItemsChanged = (value, index, key) => {
    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
    const item = {...commercial_work_order_line_items_[index]};
    item[key] = value;
    const { quantity, rate } = item;
    const total = (+quantity * +rate);
    item['total'] = total;
    commercial_work_order_line_items_[index] = {...item};

    setState(s => ({ ...s, commercial_work_order_line_items: [...commercial_work_order_line_items_] }))
  }

  // To toggle coordinate modal
  const toggleCoordinates = (index) => {
    const { coordinate, showCoordinates, commercial_work_order_line_items } = state;
    let markers = commercial_work_order_line_items[index].markers;
    Object.assign(coordinate, { markers });
    setState(s => ({ ...s, showCoordinates: !showCoordinates, coordinate: { markers }, coordinateIndex: index }))
  }

  // store drop pins
  const onSaveMarkersCoordinates = (newMarkers, mapZoom) => {
    let markerLength = newMarkers.length;
    let commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
    let coordString = "SRID=4326;MULTIPOINT("
    map(newMarkers, (x, i) => {

      if (markerLength === i + 1) {
        coordString += x.lat + " " + x.lng + ")";
      } else {
        coordString += x.lat + " " + x.lng + ",";
      }
    });
    
    const { coordinateIndex } = state;
    let item = {...commercial_work_order_line_items_[coordinateIndex]};

    if (markerLength > 0) {
      item.coordinates = coordString;
      item.totalCoordinates = markerLength;
      item.markers = newMarkers;
    }
    else {
      item.coordinates = null;
      item.totalCoordinates = markerLength;
      item.markers = newMarkers;
    }

    let allCoordinates = [];

    map(commercial_work_order_line_items_, (obj) => {
      allCoordinates = [...allCoordinates, ...obj.markers]
    });

    commercial_work_order_line_items_[coordinateIndex] = item; 
    setState(s => ({ ...s, commercial_work_order_line_items: [...commercial_work_order_line_items_], commercial_service_coordinates: allCoordinates, mapZoom: mapZoom }))
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const renderLineItems = () => {
    return (<React.Fragment> {map(commercial_work_order_line_items, (obj, index) => {
      return (
        <div className="ord-serive-block" key={`line_items${index}`}>
          <div className="ord-serive-top">
            <div className="card-title flex ai-center mb-10">
              <h4 className="m-0">Service</h4>
              <div className="ant-ico-del" onClick={() => onDeleteRowService(index)}>
                <DeleteFilled style={{ color: "red" }} />
                Delete
              </div>
            </div>
            <div className="form-group">
              <div className="fitem">
                <label>Service<sup>*</sup></label>
                <Select
                  showArrow
                  virtual={false}
                  style={{ width: '100%' }}
                  value={obj.item ? obj?.item : undefined}
                  placeholder={'Select Service'}
                  onChange={(e) => {
                    if (e) {
                      onLineItemsChanged(e, index, "item");
                    } else {
                      onLineItemsChanged('', index, "item");
                    }
                  }}
                >
                  {
                    SERVICE_TYPE_MAPPING?.map(obj => <Option value={obj.value} key={obj.value}>{obj.key}</Option>)
                  }
                </Select>
                {errors?.[`commercial_work_order_line_items[${index}].item`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].item`]}</label> : ''}
              </div>

              <div className="fitem">
                <label htmlFor={"description"}>Description</label>
                <input
                  type="text"
                  className={'form-control mb-10'}
                  placeholder={'Description'}
                  name="description"
                  id="description"
                  value={obj.description}
                  onChange={(e) => {
                    if (e) {
                      onLineItemsChanged(e.target.value, index, "description")
                    } else {
                      onLineItemsChanged('', index, "description")
                    }
                  }}
                />
              </div>

              <div className="fitem">
                <label htmlFor={"coordinates"}>Coordinates<sup>*</sup></label>
                <div className="position-relative">
                  <input
                    type="text"
                    defaultValue={0}
                    placeholder={'Coordinates'}
                    name="coordinates"
                    id="coordinates"
                    value={obj.totalCoordinates}
                    readOnly={true}
                    onClick={(e) => {
                      if (e) {
                        toggleCoordinates(index)
                      } else {
                        toggleCoordinates(index)
                      }
                    }}
                  />
                  <a href="/#" className="cord-edit" onClick={(e) => { e.preventDefault(); toggleCoordinates(index) }}>
                    <img src={EditGreen} alt="" style={{ marginRight: '6px' }} />
                    Edit
                  </a>
                </div>
                {errors?.[`commercial_work_order_line_items[${index}].coordinates`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].coordinates`]}</label> : ''}
              </div>

              <div className="fitem half-fitem">
                <div className="fitem half-fitem">
                  <label htmlFor={"quantity"}>Quantity<sup>*</sup></label>
                  <CurrencyFormat
                    value={obj.quantity}
                    allowNegative={false}
                    placeholder={"0"}
                    onValueChange={(values) => {
                      const { formattedValue, value } = values;
                      onLineItemsChanged(value, index, "quantity")
                    }} />
                  {errors?.[`commercial_work_order_line_items[${index}].quantity`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].quantity`]}</label> : ''}
                </div>

                <div className="fitem half-fitem">
                  <label htmlFor={"quantity"}>Rate<sup>*</sup></label>
                  <CurrencyFormat
                    value={obj?.rate}
                    thousandSeparator={true}
                    prefix={'$'}
                    decimalSeparator={"."}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    allowNegative={false}
                    placeholder={"$ 0.00"}
                    onValueChange={(values) => {
                      const { formattedValue, value } = values;
                      onLineItemsChanged(value, index, "rate")
                    }} />
                  {errors?.[`commercial_work_order_line_items[${index}].rate`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].rate`]}</label> : ''}
                </div>
              </div>
            </div>
            <div className="mb-8">
              <h6 className="mb-8">Miscellaneous</h6>
              {renderItemRow(index, obj?.miscallaneous_services)}
              <a className="addmore-btn" href="/#" onClick={(e) => { e.preventDefault(); setMiscellaneousRows(index) }}>
                <img src={addGreenCircle} alt="" style={{ marginRight: '6px' }} />Add Item
              </a>
            </div>
          </div>
          <div className="subs flex ai-center fs-13">
            <b>Service Total </b>
            <b className="mr-0">$ {formatToCurrency(obj?.total)}</b>
          </div>
        </div>
      )
    })}</React.Fragment>)
  }

  return (
    <React.Fragment>
      <div className="form-group">
        <div className="field-group mb-10" style={{ width: "100%" }}>
          <div className="add-service-btn">
            <a role="button" href="/#" onClick={(e) => { e.preventDefault(); setRows(); }}>
              <img src={addGreenCircle} alt="" style={{ marginRight: '6px' }}></img>
              Add Service
            </a>
          </div>
        </div>
      </div>
      {
        showCoordinates && <DefineCoordinates
          zoom={mapZoom}
          visible={showCoordinates}
          quoteDetail={quoteDetail}
          onCancel={() => toggleCoordinates(0)}
          onSave={(markers, mapZoom) => {
            onSaveMarkersCoordinates(markers, mapZoom);
          }}
          markerList={!isEmpty(coordinate.markers) ? coordinate.markers : !isEmpty(currentPosition) ? [] : []}
          currentPosition={!isEmpty(currentPosition) ? [currentPosition] : []}
          address={!isEmpty(selectedService?.service_address?.formatted_address) ? selectedService?.service_address?.formatted_address : ""}
        />
      }
      {renderLineItems()}
    </React.Fragment>
  )
}

function Products() {
  const ctx = useContext(PageContext);
  const { state, setState } = ctx;
  const { errors, commercial_work_order_line_items = [], commercial_order_line_item_type } = state;

  /**
   * AUTHOR: Ritesh Solanki
   */
  const setRows = () => {
    commercial_work_order_line_items.unshift({ id: 0, miscallaneous_services: [], created_at: moment().format("YYYY-MM-DD hh:mm:ss"), modified_at: '', item: '', model: '', item_type: commercial_order_line_item_type, description: '', rate: 0, quantity: 0, total: 0, s_and_h: 0, commercial_work_order: '' });
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items }));
  }

  const setMiscellaneousRows = (index) => {
    commercial_work_order_line_items[index].miscallaneous_services.push({mis_type:'product', price: '', item: '' });
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items }));
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const onDeleteRowService = (index) => {
    commercial_work_order_line_items.splice(index, 1);
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items }));
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const onDeleteRowMisc = (parentIndex, childIndex) => {
    commercial_work_order_line_items[parentIndex].miscallaneous_services.splice(childIndex, 1);
    let miscTotal = 0;
    map(commercial_work_order_line_items[parentIndex]["miscallaneous_services"], (obj, index) => {
      miscTotal += +obj.price;
    })
    let total = 0;
    const { quantity, rate, s_and_h } = commercial_work_order_line_items[parentIndex];
    if (quantity && rate) {
      total = (quantity * rate);
    }
    if (s_and_h) {
      total += +s_and_h;
    }
    if (miscTotal) {
      total += miscTotal;
    }
    commercial_work_order_line_items[parentIndex]['total'] = total || 0.00;
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items }));
  }

  const onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  const onLineItemsChanged = (value, index, key) => {
    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
    commercial_work_order_line_items_[index][key] = value;
    let miscTotal = 0;

    map(commercial_work_order_line_items_[index]["miscallaneous_services"], (obj, index) => {
      miscTotal += +obj.price;
    });

    let total = 0;
    const { quantity = 0, rate = 0, s_and_h = 0 } = commercial_work_order_line_items_[index];
    if (quantity && rate) {
      total = (quantity * rate);
    }
    if (s_and_h) {
      total += +s_and_h;
    }
    if (miscTotal) {
      total += miscTotal;
    }
    commercial_work_order_line_items_[index]['total'] = total;
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items_ }))
  }

  const onMiscellaneousPriceChange = (value, index, formattedValue, parentIndex) => {
    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];

    let errors = {};
    let miscTotal = 0;
    
    map(commercial_work_order_line_items_[parentIndex]["miscallaneous_services"], (obj, index) => {
      miscTotal += +obj.price;
    })
   
    let total = 0;
    const { quantity, rate, s_and_h } = commercial_work_order_line_items_[parentIndex];

    if (quantity && rate) {
      total = (quantity * rate);
    }
    if (s_and_h) {
      total += +s_and_h;
    }
    if (miscTotal) {
      total += miscTotal;
    }

    if((+parseFloat(total || 0) + value) < 0)
    {
      value = 0;
      formattedValue = "$0.00";
      errors= {miscellaneous: [{index, name: "price", message: "You can't discount more than the SO total."}]};
    }

    commercial_work_order_line_items_[parentIndex]['total'] =total.toFixed(2) || 0.00;
    commercial_work_order_line_items_[parentIndex]["miscallaneous_services"][index]['price'] = value;
    commercial_work_order_line_items_[parentIndex]["miscallaneous_services"][index]['formatted_price'] = formattedValue;

    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items_ , errors}));
  }

  const onRowDataChange = (value, parentIndex, index, key) => {
    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
    commercial_work_order_line_items_[parentIndex]["miscallaneous_services"][index][key] = value;
    
    let miscTotal = 0;
    
    map(commercial_work_order_line_items_[parentIndex]["miscallaneous_services"], (obj, index) => {
      miscTotal += +obj.price;
    })
   
    let total = 0;
    const { quantity, rate, s_and_h } = commercial_work_order_line_items_[parentIndex];
    if (quantity && rate) {
      total = (quantity * rate);
    }
    if (s_and_h) {
      total += +s_and_h;
    }
    if (miscTotal) {
      total += miscTotal;
    }

    commercial_work_order_line_items_[parentIndex]['total'] =total.toFixed(2) || 0.00;
    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items_ }))
  }

  const onMiscellaneousItemError = (item_index) => {
    let error_index = errors?.miscellaneous?.findIndex(item => item.index === item_index && item.name === "price" );

    if(error_index !== undefined && !(error_index < 0))
    {
      return <label className="new_err_msg">
        <i className="las la-info-circle" />
          {errors?.miscellaneous[error_index]?.message}
      </label>
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * @param {*} parentIndex 
   * @param {*} miscallaneous_services 
   */
  const renderItemRow = (parentIndex, miscallaneous_services) => {
    return (<React.Fragment> {map(miscallaneous_services, (item, childIndex) => {
      return (
        <div className="divrow" key={`items${childIndex}`} style={{ marginLeft: "0px", marginBottom: "10px" }}>
          {/* <div className="dcell sprice pt-0 pr-5 pl-0">
            <div className="sprice mr-0">
              <Select
                disabled={true}
                showArrow
                virtual={false}
                style={{ width: '100%' }}
                value={item?.mis_type?item?.mis_type:"Select Type"}
                onChange={(event) => {
                  onRowDataChange(event, parentIndex, childIndex, "mis_type")
                }}
              >
              </Select>
              {errors?.[`commercial_work_order_line_items[${parentIndex}].miscallaneous_services[${childIndex}].mis_type`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${parentIndex}].miscallaneous_services[${childIndex}].mis_type`]===`commercial_work_order_line_items[${parentIndex}].miscallaneous_services[${childIndex}].mis_type must be one of the following values: product, service`?"Select one":`commercial_work_order_line_items[${parentIndex}].miscallaneous_services[${childIndex}].mis_type`}</label> : ''}
            </div>
          </div> */}
          <div className="dcell sprice pt-0 pr-5 pl-0">
            <div className="sprice mr-0">
              <input
                type="text"
                value={item?.item}
                name="item"
                placeholder="Item"
                onChange={(event) => {
                  event.persist();
                  if (event) {
                    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
                    commercial_work_order_line_items_[parentIndex]["miscallaneous_services"][childIndex]["item"] = event?.target?.value;
                    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items_ }))
                  } else {
                    const commercial_work_order_line_items_ = [...state.commercial_work_order_line_items];
                    commercial_work_order_line_items_[parentIndex]["miscallaneous_services"][childIndex]["item"] = "";
                    setState(s => ({ ...s, commercial_work_order_line_items: commercial_work_order_line_items_ }))
                  }
                }}
              />
              {errors?.[`commercial_work_order_line_items[${parentIndex}].miscallaneous_services[${childIndex}].item`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${parentIndex}].miscallaneous_services[${childIndex}].item`]}</label> : ''}
            </div>
          </div>
          <div className="dcell sprice pt-0 pl-5">
            <div className="sprice mr-0" style={{ position: 'relative' }}>
              <CurrencyFormat
                value={item?.formatted_price}
                thousandSeparator={true}
                prefix={'$'}
                decimalSeparator={"."}
                decimalScale={2}
                fixedDecimalScale={true}
                allowNegative={true}
                placeholder={"$ 0.00"}
                onValueChange={(values) => {
                  const { formattedValue, value, floatValue } = values;
                  onMiscellaneousPriceChange(floatValue, childIndex, formattedValue, parentIndex);
                  this.onNumericInputChange(value);
                }}  
              />
              {
                onMiscellaneousItemError(childIndex)
              }
              {/* <InputNumber
                defaultValue={0.00}
                formatter={value => value ? `$ ${value}` : `${value}`}
                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                value={item?.price}
                name="price"
                placeholder="Price"
                min="0"
                onChange={(e) => {
                  if (e && !isNaN(e) && JSON.parse(e) >= 0) {
                    onRowDataChange(e, parentIndex, childIndex, "price")
                  } else {
                    onRowDataChange(0, parentIndex, childIndex, "price")
                  }
                }}
              /> */}
              {errors?.[`commercial_work_order_line_items[${parentIndex}].miscallaneous_services[${childIndex}].price`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${parentIndex}].miscallaneous_services[${childIndex}].price`]}</label> : ''}
            </div>
          </div>
          <CloseOutlined style={{ marginTop: "14px" }} onClick={() => onDeleteRowMisc(parentIndex, childIndex)}></CloseOutlined>
        </div>
      )
    })}</React.Fragment>)
  }

  /**
   * AUTHOR: Ritesh Solanki
   */
  const renderLineItems = () => {
    return (<React.Fragment> {map(commercial_work_order_line_items, (obj, index) => {
      return (
        <div className="ord-serive-block" key={`line_items${index}`}>
          <div className="ord-serive-top">
            <div className="card-title flex ai-center mb-10">
              <h4 className="m-0">Product</h4>
              <div className="ant-ico-del" onClick={() => onDeleteRowService(index)}>
                <DeleteFilled style={{ color: "red" }} />
                Delete
              </div>
            </div>
            <div className="form-group">
              <div className="fitem half-fitem">
                <div className="fitem half-fitem">
                  <label>Product<sup>*</sup></label>
                  <Select
                    showArrow
                    virtual={false}
                    style={{ width: '100%' }}
                    value={obj.item ? obj?.item : undefined}
                    placeholder={'Select Product'}
                    onChange={(e) => {
                      if (e) {
                        onLineItemsChanged(e, index, "item")
                      } else {
                        onLineItemsChanged('', index, "item")
                      }
                    }}
                  >
                    {
                      PRODUCT_TYPE_MAPPING?.map(obj => <Option value={obj.value} key={obj.value}>{obj.key}</Option>)
                    }
                  </Select>
                  {errors?.[`commercial_work_order_line_items[${index}].item`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].item`]}</label> : ''}
                </div>

                <div className="fitem half-fitem">
                  <label>Model<sup>*</sup></label>
                  <Select
                    showArrow
                    virtual={false}
                    style={{ width: '100%' }}
                    value={obj.model ? obj?.model : undefined}
                    placeholder={'Select Model'}
                    onChange={(e) => {
                      if (e) {
                        onLineItemsChanged(e, index, "model")
                      } else {
                        onLineItemsChanged('', index, "model")
                      }
                    }}
                  >
                    <Option value="mounted">Mounted</Option>
                    <Option value="header_bags">Header Bags</Option>
                  </Select>
                  {errors?.[`commercial_work_order_line_items[${index}].model`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].model`]}</label> : ''}
                </div>

              </div>

              <div className="fitem">
                <label htmlFor={"description"}>Description</label>
                <input
                  type="text"
                  className={'form-control mb-10'}
                  placeholder={'Description'}
                  name="description"
                  id="description"
                  value={obj.description}
                  onChange={(e) => {
                    if (e) {
                      onLineItemsChanged(e?.target?.value, index, "description")
                    } else {
                      onLineItemsChanged('', index, "description")
                    }
                  }}
                />
              </div>

              <div className="fitem half-fitem">
                <div className="fitem half-fitem">
                  <label htmlFor={"quantity"}>Quantity<sup>*</sup></label>
                  <CurrencyFormat
                    value={obj.quantity}
                    allowNegative={false}
                    placeholder={"0"}
                    onValueChange={(values) => {
                      const { formattedValue, value } = values;
                      onLineItemsChanged(value, index, "quantity")
                    }} />

                  {/* <InputNumber
                    defaultValue={0}
                    placeholder={'Quantity'}
                    name="quantity"
                    id="quantity"
                    value={obj.quantity}
                    onChange={(e) => {
                      if (e) {
                        onLineItemsChanged(e, index, "quantity")
                      } else {
                        onLineItemsChanged('', index, "quantity")
                      }
                    }}
                  /> */}
                  {errors?.[`commercial_work_order_line_items[${index}].quantity`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].quantity`]}</label> : ''}
                </div>

                <div className="fitem half-fitem">
                  <label htmlFor={"rate"}>Rate<sup>*</sup></label>
                  <CurrencyFormat
                    value={obj?.rate}
                    thousandSeparator={true}
                    prefix={'$'}
                    decimalSeparator={"."}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    allowNegative={false}
                    placeholder={"$ 0.00"}
                    onValueChange={(values) => {
                      const { formattedValue, value } = values;
                      onLineItemsChanged(value, index, "rate")
                    }} />

                  {/* <InputNumber
                    defaultValue={0.00}
                    formatter={value => value ? `$ ${value}` : `0.00`}
                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                    placeholder={'Rate'}
                    name="rate"
                    id="rate"
                    value={obj?.rate}
                    onChange={(e) => {
                      if (e) {
                        onLineItemsChanged(e, index, "rate")
                      } else {
                        onLineItemsChanged('', index, "rate")
                      }
                    }}
                  /> */}
                  {errors?.[`commercial_work_order_line_items[${index}].rate`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].rate`]}</label> : ''}
                </div>
                <div className="fitem half-fitem">
                  <label htmlFor={"s_and_h"}>S&H<sup>*</sup></label>
                  <CurrencyFormat
                    value={obj?.s_and_h}
                    thousandSeparator={true}
                    prefix={'$'}
                    decimalSeparator={"."}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    allowNegative={false}
                    placeholder={"$ 0.00"}
                    onValueChange={(values) => {
                      const { formattedValue, value } = values;
                      onLineItemsChanged(value, index, "s_and_h")
                    }} />
                  {/* <InputNumber
                    defaultValue={0.00}
                    formatter={value => value ? `$ ${value}` : `0.00`}
                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                    placeholder={'S&H'}
                    name="s_and_h"
                    id="s_and_h"
                    value={obj?.s_and_h}
                    onChange={(e) => {
                      if (e) {
                        onLineItemsChanged(e, index, "s_and_h")
                      } else {
                        onLineItemsChanged('', index, "s_and_h")
                      }
                    }}
                  /> */}
                  {errors?.[`commercial_work_order_line_items[${index}].s_and_h`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`commercial_work_order_line_items[${index}].s_and_h`]}</label> : ''}
                </div>
              </div>
            </div>
            <div className="mb-8">
              <h6 className="mb-8">Miscellaneous</h6>
              {renderItemRow(index, obj?.miscallaneous_services)}
              <a className="addmore-btn" href="/#" onClick={(e) => { e.preventDefault(); setMiscellaneousRows(index) }}>
                <img src={addGreenCircle} alt="" style={{ marginRight: '6px' }} />Add Item
              </a>
            </div>
          </div>
          <div className="subs flex ai-center fs-13">
            <b>Product Total </b>
            <b className="mr-0">{obj?.total ? `$ ${obj?.total}` : `$ 0.00`}</b>
          </div>

        </div>
      )
    })}</React.Fragment>)
  }

  return (
    <React.Fragment>
      <div className="form-group">
        <div className="field-group" style={{ width: "100%", paddingRight: 5 }}>
          <div className="add-service-btn">
            <a role="button" href="/#" onClick={(e) => { e.preventDefault(); setRows() }}>
              <img src={addGreenCircle} alt="" style={{ marginRight: '6px' }}></img>
              Add Product
            </a>
          </div>
        </div>
      </div>
      {renderLineItems()}
    </React.Fragment>
  )
}

function ServiceTotal() {
  const ctx = useContext(PageContext);
  const { state, setState } = ctx;
  const { commercial_work_order_line_items, commercial_detail, commercial_order_line_item_type } = state;
  let total = 0;
  var result = [];
  if (commercial_work_order_line_items !== undefined) {
    commercial_work_order_line_items.reduce(function (res, value) {
      if (!res[value.item]) {
        res[value.item] = { item: value.item, total: 0 };
        result.push(res[value.item])
      }
      res[value.item].total += parseFloat(value.total).toFixed(2);
      return res;
    }, {});
  }
  return (
    <div className="mt-10 serv-ord-total">
      <div className="sdetail fs-13">
        {map(result, (obj, index) => {
          total += parseFloat(obj.total).toFixed(2);
          return (
            obj.item !== '' && <div key={`ServiceTotal_items${index}`} className="subs flex mt-8">
              {commercial_order_line_item_type === "service" && <span className="service-type-title">{SERVICE_TYPE[obj.item]}</span>}
              {commercial_order_line_item_type === "product" && <span className="service-type-title">{PRODUCT_TYPE[obj.item]}</span>}
              <div className="flex" key={`clean_area_total`}>
                <div className="flex-1"></div>
                <div className="">$ {formatToCurrency(obj.total)}</div>
              </div>
            </div>
          )
        })}
        <div className="subs mt-8">
          <span className="flex ai-center">
            {commercial_order_line_item_type === "service" && <b>Servicer Order Total (excl. tax)</b>}
            {commercial_order_line_item_type !== "service" && <b>Work Order Total (excl. tax)</b>}
            <b className="mr-0">$ {formatToCurrency(total)}</b>
          </span>
        </div>
      </div>
    </div>
  )
}
